// eslint-disable-next-line import/prefer-default-export
export const getInstagramLink = (instaProfile) => `https://www.instagram.com/${instaProfile}/`;
